export const OverviewSources = {
  NZ: {
    visit_our_website: {
      label: 'visit our website',
      url: 'https://www.gemfinance.co.nz/',
    },
    privacy_acknowledgement_and_authorisation: {
      label: 'Latitude NZ Privacy Notice',
      url: 'https://assets.latitudefinancial.com/gem-essentials/nz-gem-visa-privacy-notice.pdf',
    },
    gem_visa_conditions_of_use: {
      label: 'Conditions of Use',
      url:
        'https://assets.gemfinance.co.nz/legals/conditions-of-use/gemvisa-nz/cou.pdf?_ga=2.236588865.1323252382.1615416779-941858851.1587360214',
    },
    initial_disclosure_statement: {
      label: 'Initial Disclosure Statement',
      url: 'https://assets.latitudefinancial.com/gem-essentials/nz-gem-visa-ids.pdf',
    },
    important_information: {
      label: 'Important Information',
      url: 'https://www.gemfinance.co.nz/gem-visa-info/',
    },
    gemfinance_url: {
      label: 'gemfinance.co.nz',
      url: 'http://gemfinance.co.nz/',
    },
    lawyers_conveyancers_act: {
      label: 'Lawyers and Conveyancers Act 2006',
      url: 'http://www.legislation.govt.nz/act/public/2006/0001/latest/whole.html#dlm364939',
    },
  },
  AU: {
    visit_our_website: {
      label: 'visit our website',
      url: 'https://www.gemfinance.co.nz/',
    },
    lfs_credit_cards: {
      label: 'latitudefinancial.com.au',
      url: 'https://latitudefinancial.com.au',
    },
    latitude_gem_visa: {
      label: 'Latitude Gem Visa',
      url:
        'https://www.latitudefinancial.com.au/credit-cards/gem-visa-card.html?_ga=2.258137802.1355450623.1583383490-1396169284.1569977644',
    },
    latitude_go_card: {
      label: 'Latitude GO Mastercard',
      url: 'https://www.latitudefinancial.com.au/credit-cards/gomastercard',
    },
    latitude_afs_card: {
      label: 'CreditLine',
      url: 'https://www.latitudefinancial.com.au/credit-cards/apple-creditline',
    },
    latitude_28d_mastercard: {
      label: 'Latitude 28° Global Platinum Mastercard',
      url:
        'https://www.latitudefinancial.com.au/credit-cards/28-degrees/?_ga=2.258137802.1355450623.1583383490-1396169284.1569977644',
    },
    latitude_low_rate_mastercard: {
      label: 'Latitude Low Rate Mastercard',
      url: 'https://www.latitudefinancial.com.au/credit-cards/low-rate',
    },
    privacy_notice: {
      url: 'https://www.latitudefinancial.com.au/privacy',
      label: 'Privacy Notice',
    },
    dj_privacy_notice: {
      label: 'Privacy Notice',
      url: 'https://assets.latitudefinancial.com/legals/david-jones-credit-card-privacy-notice.html',
    },
    privacy_policy: {
      label: 'Privacy Policy',
      url: 'https://www.latitudefinancial.com.au/privacy',
    },
    key_facts_sheet: {
      label: 'Key Facts Sheet',
      url:
        'https://assets.latitudefinancial.com/legals/key-fact-sheet/gemvisa-au/kfs.html?_ga=2.100241886.1355450623.1583383490-1396169284.1569977644',
    },
    gem_key_facts_sheet: {
      label: 'Key Facts Sheet',
      url: 'https://assets.latitudefinancial.com/legals/key-fact-sheet/gemvisa-au/kfs.html',
    },
    twenty_eight_degrees_key_facts_sheet: {
      label: 'Key Facts Sheet',
      url: 'https://assets.latitudefinancial.com/legals/key-fact-sheet/28-degrees/kfs.html',
    },
    low_rate_key_facts_sheet: {
      label: 'Key Facts Sheet',
      url: 'https://assets.latitudefinancial.com/legals/key-fact-sheet/low-rate/kfs.html',
    },
    go_key_facts_sheet: {
      label: 'Key Facts Sheet',
      url: 'https://assets.latitudefinancial.com/legals/key-fact-sheet/gomc/kfs.html',
    },
    afs_key_facts_sheet: {
      label: 'Key Facts Sheet',
      url: 'https://assets.latitudefinancial.com/legals/key-fact-sheet/creditline-afs/kfs.html',
    },
    premiere_key_facts_sheet: {
      url: 'https://assets.latitudefinancial.com/legals/key-fact-sheet/DJ-Premiere/KFS.html',
      label: 'Key Facts Sheet',
    },
    prestige_key_facts_sheet: {
      url: 'https://assets.latitudefinancial.com/legals/key-fact-sheet/DJ-Prestige/KFS.html',
      label: 'Key Facts Sheet',
    },
    gem_conditions_of_use: {
      label: 'Latitude Credit Card General Terms and Conditions',
      url: 'https://assets.latitudefinancial.com/legals/credit-card-general-terms-and-conditions.pdf',
    },
    twenty_eight_degrees_conditions_of_use: {
      label: 'Latitude Credit Card General Terms and Conditions',
      url: 'https://assets.latitudefinancial.com/legals/credit-card-general-terms-and-conditions.pdf',
    },
    go_conditions_of_use: {
      label: 'Latitude Credit Card General Terms and Conditions',
      url: 'https://assets.latitudefinancial.com/legals/credit-card-general-terms-and-conditions.pdf',
    },
    afs_conditions_of_use: {
      label: 'Conditions of Use',
      url: 'https://assets.latitudefinancial.com/legals/conditions-of-use/creditline-afs/cou.pdf',
    },
    low_rate_conditions_of_use: {
      label: 'Latitude Credit Card General Terms and Conditions',
      url: 'https://assets.latitudefinancial.com/legals/credit-card-general-terms-and-conditions.pdf',
    },
    david_jones_conditions_of_use: {
      label: 'David Jones Credit Card General Terms and Conditions',
      url: 'https://assets.latitudefinancial.com/legals/david-jones-credit-card-general-terms-and-conditions.pdf',
    },
    david_jones_rewards_program_terms_and_conditions: {
      label: 'David Jones Credit Card Rewards Program Terms and Conditions',
      url: 'https://assets.latitudefinancial.com/legals/terms-conditions/david-jones-credit-card-rewards.pdf',
    },
    important_information: {
      label: 'Important Information',
      url: 'https://www.gemfinance.co.nz/gem-visa-info/',
    },
    privacy_acknowledgement_and_authorisation: {
      label: 'Important Privacy Notice',
      url: 'https://dsa.apply.gemvisa.co.nz/eapps/PrivacyPolicyPrint.faces?cardType=gemvisanz',
    },
    gem_visa_conditions_of_use: {
      label: 'Conditions of Use',
      url:
        'https://assets.gemfinance.co.nz/legals/conditions-of-use/gemvisa-nz/cou.pdf?_ga=2.236588865.1323252382.1615416779-941858851.1587360214',
    },
    initial_disclosure_statement: {
      label: 'Initial Disclosure Statement',
      url: 'https://assets.latitudefinancial.com/gem-essentials/nz-gem-visa-ids.pdf',
    },
    gemfinance_url: {
      label: 'gemfinance.co.nz',
      url: 'http://gemfinance.co.nz/',
    },
    gem_visa_terms_and_condition: {
      label: 'T&Cs apply',
      url: 'https://assets.latitudefinancial.com/legals/terms-conditions/gemvisa-rewards.pdf',
    },
    gem_visa_interest_free: {
      label: 'Find more details',
      url:
        'https://latitudefs.zendesk.com/hc/en-au/articles/4409706884113-Your-Guide-to-Receive-6-Months-Interest-Free-on-250-Purchases-within-30-Days?gemid2=lfs-web%3Acards%3Agem-visa%3Aheres-how%3A0-interest-on-250-plus-purchase&_gl=1*1t0b0wk*_gcl_au*MzY0NTY1NjkzLjE3Njc2NTkyNDM.*_ga*MTEyMjk2NjQ1LjE3NTg2MDM4MDk.*_ga_HN02VX7PXM*czE3NzM4NzIyNTYkbzUxJGcxJHQxNzczODc0NDg1JGo1OCRsMCRoMA..*_ga_VZY6JWYT4Y*czE3NzM4NzIyNTYkbzE0NyRnMSR0MTc3Mzg3NDQ4NSRqNTgkbDAkaDA.',
    },
    learnMore: {
      label: 'Learn more',
      url: 'https://www.davidjones.com/faq/david-jones-american-express-card',
    },
    disclaimerZenDeskLink: {
      label: 'Learn more',
      url:
        'https://latitudefs.zendesk.com/hc/en-au/articles/47612890587921-David-Jones-Credit-Card-Changes-Effective-25-August-2026',
    },
    auPostForm: {
      label: 'Download form',
      url: 'https://assets.latitudefinancial.com/forms/cards/identity-verification/identity-verification.pdf',
    },
    findAuPost: {
      label: 'Bank@Post facility',
      url: 'https://auspost.com.au/locate/?services=113',
    },
    findAppleStore: {
      storeName: 'Apple',
      label: 'Find Apple Store',
      url: 'https://www.apple.com/au/retail/',
    },
    afs_apple: {
      label: 'Apple',
      url: 'https://www.apple.com/au/shop/browse/financing',
    },
    afs_rates_fees: {
      label: 'Rates and Fees',
      url: 'https://www.latitudefinancial.com.au/credit-cards/apple-creditline',
    },
    twenty_eight_degrees_rates_fees: {
      label: 'Rates and Fees',
      url: 'https://www.latitudefinancial.com.au/credit-cards/28-degrees/',
    },
    interest_free_detail: {
      label: 'Find more details',
      url:
        'https://latitudefs.zendesk.com/hc/en-au/articles/4409706884113-Latitude-GO-Mastercard-s-6-months-Interest-Free',
    },
    terms_conditions: {
      label: 'Terms and Conditions',
      url: 'https://www.latitudefinancial.com.au/terms-and-conditions',
    },
    security: {
      label: 'Security',
      url: 'https://www.latitudefinancial.com.au/security',
    },
    click_to_pay: {
      label: 'Click to Pay',
      url: 'https://www.mastercard.com/global/click-to-pay/en-au/terms-of-use.html',
    },
    statement_of_notifiable_matters: {
      label: 'Statement of Notifiable Matters',
      url: 'https://www.latitudefinancial.com.au/privacy/',
    },
    lfs_credit_card_ecomms_consent: {
      label: 'Latitude Financial Services - Electronic Communications Consent',
      url: 'https://assets.latitudefinancial.com/legals/latitude-credit-cards-ecomms-consent.html',
    },
  },
};

export const FooterSources = {
  privacy_policy: {
    label: 'Privacy and Credit Reporting Policy',
    url: 'https://www.gemfinance.co.nz/privacy/',
  },
  terms_and_conditions: {
    label: 'Terms and Conditions of Use',
    url: 'https://www.gemfinance.co.nz/terms-and-conditions/',
  },
  security: {
    label: 'Security',
    url: 'https://www.gemfinance.co.nz/security/',
  },
};

export const OutcomeApprovedSources = {
  pdf: {
    initial_disclosure_statement: {
      label: 'Initial Disclosure Statement',
      url: 'https://assets.latitudefinancial.com/gem-essentials/nz-gem-visa-ids.pdf',
    },
    initial_disclosure_statement_FY2023_Q3: {
      label: 'Initial Disclosure Statement',
      url: 'https://assets.latitudefinancial.com/gem-essentials/nz-gem-visa-ids.pdf',
    },
    conditions_of_use: {
      label: 'Conditions of Use',
      url: 'https://assets.latitudefinancial.com/legals/conditions-of-use/gemvisa-nz/cou.pdf',
    },
  },
  shoppingInformation: {
    use_account_number: {
      label: 'Get started now',
      location: 'Shop with Interest Free, from 12 months to 60 months',
      url: 'https://www.gemfinance.co.nz/credit-cards/interest-free-offers/',
    },
    google_store: {
      label: 'Google Play',
      location: 'outcome',
      url: 'https://play.google.com/store/apps/details?id=com.latitudefinancial.latitudeapp&hl=en_NZ&gl=US',
    },
    apple_store: {
      label: 'App Store',
      location: 'outcome',
      url: 'https://apps.apple.com/nz/app/latitude-app/id1373059866',
    },
  },
  featureInformation: {
    interest_free: {
      label: 'more about 6 months Interest Free',
      location: '6 months interest free',
      url: 'https://www.gemfinance.co.nz/credit-cards/gem-visa-card/',
    },
    long_term_interest_free: {
      label: 'more about long term interest free',
      location: 'Get long term interest free - from 6 to 60 months',
      url: 'https://www.gemfinance.co.nz/credit-cards/interest-free-offers/',
    },
  },
};

export const OutcomeApprovedSourcesAu = {
  shoppingInformation: {
    google_store: {
      label: 'Google Play',
      location: 'outcome',
      url: 'https://play.google.com/store/apps/details?id=com.latitudefinancial.latitudeapp&hl=en_AU&gl=AU',
    },
    apple_store: {
      label: 'App Store',
      location: 'outcome',
      url: 'https://apps.apple.com/au/app/latitude-app/id1373059866',
    },
  },
  appleOnlineStore: {
    label: 'Apple Online Store',
    location: 'outcome',
    url: 'https://www.apple.com/au/shop/browse/financing',
  },
  findAppleStore: {
    label: 'Find an Apple Retail Store',
    location: 'outcome',
    url:
      'https://www.apple.com/au/retail/?_gl=1*1dosvma*_ga*MTQxNzk2ODAzOC4xNzEzNDA3OTY3*_ga_EJBPRE662F*MTcyMjQyNTE1My4xMS4xLjE3MjI0MjU3NjQuMC4wLjA',
  },
  merchantList: {
    label: 'Australia’s leading retailers',
    url: 'https://www.latitudefinancial.com.au/interest-free/find-a-store',
  },
};

export const ProductComparisonLinks = {
  dj_premiere_compare: {
    url: 'https://www.davidjones.com/david-jones-credit-card/compare/premiere',
  },
  dj_prestige_compare: {
    url: 'https://www.davidjones.com/david-jones-credit-card/compare/prestige',
  },
  dj_compare_cards: {
    url: 'https://www.davidjones.com/david-jones-credit-card/compare',
  },
  about_us: {
    url: 'https://www.latitudefinancial.com.au/about-us',
  },
};

export const AdditionalCardHolderLinks = {
  privacy_policy: {
    url: 'https://www.latitudefinancial.com.au/privacy',
    label: 'Privacy Policy',
  },
};
